import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, LocalService, PageKey, Wrappers10 } from 'src/service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';

@Component({
  selector: 'app-biz-subscriptions',
  templateUrl: './biz-subscriptions.component.html',
  styleUrl: './biz-subscriptions.component.scss'
})
export class BizSubscriptionsComponent {
  lstSectionConfigKeys: string[] = ["table"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; wrapper: Wrappers10;

  maxBodyHeight = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private router: Router, private planPurchaseService: PlanPurchaseService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.BusinessSubscriptions);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    this.planPurchaseService.getPlanSubscriptions(this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }


  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.selected.countryCode) {
      const ctryCode = this.localService.selected.countryCode == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.selected.countryCode + '-' + this.localService.asCtryCode);

      this.router.navigate([['/biz-subscriptions', ctryCode, this.localService.selected.user, InteractionType.Bill_PnixSoft].join('/')]);
    }
  }
}
